import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function BilisselEsneklikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['bilissel-esneklik-testi']} />;
}
